import React from 'react';
import { Container, Row } from 'reactstrap';

import AlternativeProductDetail from '../AlternativeProductDetail/AlternativeProductDetail';

const AlternativeProducts = (props) => {
    return (
        <div>
        <Container>
            <Row id="alternative-products">
                {props.alternativeProducts
                    .map((item, index) => (<AlternativeProductDetail
                        key={index}
                        manufacturer={item.vendor}
                        title={item.title}
                        tid={item.technopedia_id}/>))}
            </Row>
        </Container>
        </div>
    )
}

export default AlternativeProducts;



// WEBPACK FOOTER //
// ./src/components/AlternativeProducts/AlternativeProducts.js